<template>
    <svg width="20" height="32" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 23L13.5 16L6.5 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
</template>
